import { UserSessionCookieManager } from '@studyportals/client-internal-platform-sso';
import { SessionTokenRequestSigner } from '@studyportals/client-internal-platform-sso';
import { SignedRequestSender, BaseSuperAgentRequestFactory } from '@studyportals/mb-platform-http-requests';

const domain = env.cognitoDomain; // eslint-disable-line
const cognitoClientId = env.cognitoClientId; // eslint-disable-line
const cognitoPoolId = env.cognitoPoolId; // eslint-disable-line

const userSessionOperations = new UserSessionCookieManager(cognitoClientId, cognitoPoolId, domain);
const requestFactory = new BaseSuperAgentRequestFactory();
const requestSigner = new SessionTokenRequestSigner(userSessionOperations);
const requestSender = new SignedRequestSender(requestSigner);

const dataAccessLayer = {

	accessToken: '',
	async get(url) {
		const request = requestFactory.get(url);
		let anwser;

		try {
			const response = await requestSender.send(request);
			anwser = response.body;
			return anwser;
		}
		catch (e) {
			console.warn('dqs-display-module', e);// eslint-disable-line
			return [];
		}
	}
};

export default dataAccessLayer;
